// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddTopLevelIconAndText-module__container___LsgJ_ {
    position: relative;
    width: 100%;
    height: 100%;
}

.AddTopLevelIconAndText-module__promiseAndStatusContainer___xn6yD {
    display: flex;
}

.AddTopLevelIconAndText-module__dropdownContainer___pV9Xf {
    position: relative;
    display: flex;
    justify-content: space-between;
    font-weight: 800;
    position: relative;
    z-index: 31; /* higher than the topbar z-index*/
}

.AddTopLevelIconAndText-module__downloadButton___OBTN6 {
    background-color: var(--bmo-primary-color-mint);
    color: white;
    padding: 10px 15px;
    border: 0;
    transition: background-color 0.3s ease, transform 0.2s ease;
    height: 100%;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.1), 0 0 100px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 2px;
    border-radius: 8px;
    font-weight: 500;
    justify-content: center;
}

    .AddTopLevelIconAndText-module__downloadButton___OBTN6:hover {
        background-color: var(--bmo-primary-color-mint-dark);
    }

.AddTopLevelIconAndText-module__downloadButtonWithBorder___vFdYA {
    border: 2px solid white;
}

.AddTopLevelIconAndText-module__downloadButtonDisabled____vtMN {
    background-color: #88d8de;
    cursor: not-allowed;
    opacity: 0.8;
    transform: none !important;
}

    .AddTopLevelIconAndText-module__downloadButtonDisabled____vtMN:hover {
        background-color: #88d8de;
    }

.AddTopLevelIconAndText-module__downloadIcon___BB3l8 {
    width: 20px;
    height: 20px;
}

.AddTopLevelIconAndText-module__downloadMenu___O7H2V {
    background-color: white;
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    padding: 8px 0;
    min-width: 200px;
    max-height: 300px;
    overflow-y: auto;
    margin-top: 4px;
    z-index: 100;
}

.AddTopLevelIconAndText-module__downloadMenuItem___LBWFR {
    font-size: 15px;
    padding: 10px 16px;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    /* Make sure we use the same font as the rest of the PoD */
    font-family: 'BauerMediaSans';
    cursor: pointer;
    color: #333;
    border-left: 3px solid transparent;
}

    .AddTopLevelIconAndText-module__downloadMenuItem___LBWFR:hover {
        background-color: #f0f9fa;
        color: var(--bmo-primary-color-mint-dark);
        border-left: 3px solid var(--bmo-primary-color-mint);
    }

.AddTopLevelIconAndText-module__downloadMenuItemDisabled___wb7JB {
    color: #bbb;
    cursor: not-allowed;
    background-color: #f9f9f9;
}

    .AddTopLevelIconAndText-module__downloadMenuItemDisabled___wb7JB:hover {
        background-color: #f9f9f9;
        color: #bbb;
        border-left: 3px solid transparent;
    }

.AddTopLevelIconAndText-module__dropdownArrow___Yjp2k {
    margin-left: 6px;
    width: 12px;
    height: 12px;
    transition: transform 0.2s ease;
    filter: brightness(1)
}

.AddTopLevelIconAndText-module__dropdownOpen___ynE6V .AddTopLevelIconAndText-module__dropdownArrow___Yjp2k {
    transform: rotate(180deg);
}

/* Export error message */
.AddTopLevelIconAndText-module__exportError____9M4V {
    position: absolute;
    top: 100%;
    left: 0;
    background-color: #f8d7da;
    color: #721c24;
    padding: 10px 15px;
    border-radius: 4px;
    margin-top: 8px;
    font-size: 14px;
    z-index: 100;
    white-space: normal;
    max-width: 300px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border-left: 4px solid #dc3545;
}

.AddTopLevelIconAndText-module__topBar___DKXZx {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 55px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    z-index: 30; /* Higher than submenu (submenu is another component)*/
}

.AddTopLevelIconAndText-module__leftSection___Z741R {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-top: 10px;
    min-height: 60px;
    margin-top: 15px;
}

.AddTopLevelIconAndText-module__statusTextContainer___IUVYD {
    height: 20px;
    margin-top: 10px;
}

.AddTopLevelIconAndText-module__spacer___hvi9s {
    width: 16px;
    flex-shrink: 0;
}

.AddTopLevelIconAndText-module__statusText___wGNLW {
    font-size: 16px;
    font-weight: 500;
    color: #4b5563;
    line-height: 1.2;
}

.AddTopLevelIconAndText-module__circleContainer___z6VCi {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.AddTopLevelIconAndText-module__circle___oDSbg {
    width: 50px;
    height: 50px;
    background-color: #d9d9d9;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.AddTopLevelIconAndText-module__circleImage___cKYly {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    object-fit: cover;
}

.AddTopLevelIconAndText-module__circleText___YWzjq {
    font-size: 12px;
    color: white;
    font-weight: bold;
    text-align: center;
}

.AddTopLevelIconAndText-module__circleWithText___j_KMR {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    margin-top: 30px;
}

.AddTopLevelIconAndText-module__circleWithText___j_KMR,
.AddTopLevelIconAndText-module__circleImage___cKYly {
    background-color: #e5e7eb;
    border: 1px solid #e5e7eb;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.1), 0 0 100px rgba(0, 0, 0, 0.1);
    transform-style: preserve-3d;
    transition: transform 0.3s ease;
}

.AddTopLevelIconAndText-module__circleDescription___pllbB {
    margin-top: 8px;
    font-size: 13px;
    text-align: center;
    color: black;
    font-weight: bold;
    word-wrap: break-word;
    max-width: 120px;
}

.AddTopLevelIconAndText-module__productPromiseColor___ca24M {
    background-color: var(--bmo-primary-color-lavender);
}

.AddTopLevelIconAndText-module__wrappedContent___aKV9B {
    width: 100%;
    height: 100%;
    display: flex;
}

.AddTopLevelIconAndText-module__bottomBar___n0FqW {
    position: absolute;
    bottom: 16px;
    right: 16px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 8px 16px;
    z-index: 10;
}

    .AddTopLevelIconAndText-module__bottomBar___n0FqW .AddTopLevelIconAndText-module__statusText___wGNLW {
        margin-right: 0; /* Override the auto margin from topBar */
    }

/* Map URL Modal Styles */
.AddTopLevelIconAndText-module__modalOverlay___sSJN5 {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;
    pointer-events: auto;
}

.AddTopLevelIconAndText-module__modal___BzIKB {
    background-color: white;
    border-radius: 8px;
    padding: 24px;
    max-width: 600px;
    width: 90%;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    animation: AddTopLevelIconAndText-module__modalFadeIn___Ulpgi 0.3s ease-out;
}

@keyframes AddTopLevelIconAndText-module__modalFadeIn___Ulpgi {
    from {
        opacity: 0;
        transform: translateY(-20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.AddTopLevelIconAndText-module__modal___BzIKB h3 {
    margin-top: 0;
    margin-bottom: 16px;
    color: #111827;
    font-size: 1.25rem;
}

.AddTopLevelIconAndText-module__urlContainer___Tldyj {
    display: flex;
    margin: 16px 0;
}

.AddTopLevelIconAndText-module__urlInput___hMGCU {
    flex: 1;
    padding: 8px 12px;
    border: 1px solid #d1d5db;
    border-radius: 4px 0 0 4px;
    font-size: 14px;
    background-color: #f9fafb;
}

.AddTopLevelIconAndText-module__copyButton____IsT4 {
    background-color: var(--bmo-primary-color-mint);
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 8px;
    /* border-radius: 0 4px 4px 0; */
    cursor: pointer;
    font-weight: 500;
    transition: background-color 0.3s;
}

    .AddTopLevelIconAndText-module__copyButton____IsT4:hover {
        background-color: var(--bmo-primary-color-mint-dark);
    }

.AddTopLevelIconAndText-module__modalNote___UCDyT {
    color: #6b7280;
    font-size: 14px;
    margin-bottom: 20px;
}

.AddTopLevelIconAndText-module__modalButtons___de2yq {
    display: flex;
    justify-content: flex-end;
}

.AddTopLevelIconAndText-module__closeButton___MvrRH {
    background-color: #e5e7eb;
    color: #111827;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
    transition: background-color 0.3s;
}

    .AddTopLevelIconAndText-module__closeButton___MvrRH:hover {
        background-color: #d1d5db;
    }
`, "",{"version":3,"sources":["webpack://./app/components/ProofOfDeliveryLayout/HigherOrderComponents/AddTopLevelIconAndText/AddTopLevelIconAndText.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,WAAW,EAAE,kCAAkC;AACnD;;AAEA;IACI,+CAA+C;IAC/C,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,2DAA2D;IAC3D,YAAY;IACZ,sGAAsG;IACtG,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;AAC3B;;IAEI;QACI,oDAAoD;IACxD;;AAEJ;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,0BAA0B;AAC9B;;IAEI;QACI,yBAAyB;IAC7B;;AAEJ;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,0CAA0C;IAC1C,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,0DAA0D;IAC1D,6BAA6B;IAC7B,eAAe;IACf,WAAW;IACX,kCAAkC;AACtC;;IAEI;QACI,yBAAyB;QACzB,yCAAyC;QACzC,oDAAoD;IACxD;;AAEJ;IACI,WAAW;IACX,mBAAmB;IACnB,yBAAyB;AAC7B;;IAEI;QACI,yBAAyB;QACzB,WAAW;QACX,kCAAkC;IACtC;;AAEJ;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,wCAAwC;IACxC,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,WAAW,EAAE,sDAAsD;AACvE;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,yBAAyB;IACzB,yBAAyB;IACzB,sGAAsG;IACtG,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;AACf;;IAEI;QACI,eAAe,EAAE,yCAAyC;IAC9D;;AAEJ,yBAAyB;AACzB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,UAAU;IACV,0CAA0C;IAC1C,2EAAoC;AACxC;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,iBAAiB;IACjB,yBAAyB;IACzB,0BAA0B;IAC1B,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,+CAA+C;IAC/C,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,iCAAiC;AACrC;;IAEI;QACI,oDAAoD;IACxD;;AAEJ;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iCAAiC;AACrC;;IAEI;QACI,yBAAyB;IAC7B","sourcesContent":[".container {\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n\n.promiseAndStatusContainer {\n    display: flex;\n}\n\n.dropdownContainer {\n    position: relative;\n    display: flex;\n    justify-content: space-between;\n    font-weight: 800;\n    position: relative;\n    z-index: 31; /* higher than the topbar z-index*/\n}\n\n.downloadButton {\n    background-color: var(--bmo-primary-color-mint);\n    color: white;\n    padding: 10px 15px;\n    border: 0;\n    transition: background-color 0.3s ease, transform 0.2s ease;\n    height: 100%;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.1), 0 0 100px rgba(0, 0, 0, 0.1);\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 2px;\n    border-radius: 8px;\n    font-weight: 500;\n    justify-content: center;\n}\n\n    .downloadButton:hover {\n        background-color: var(--bmo-primary-color-mint-dark);\n    }\n\n.downloadButtonWithBorder {\n    border: 2px solid white;\n}\n\n.downloadButtonDisabled {\n    background-color: #88d8de;\n    cursor: not-allowed;\n    opacity: 0.8;\n    transform: none !important;\n}\n\n    .downloadButtonDisabled:hover {\n        background-color: #88d8de;\n    }\n\n.downloadIcon {\n    width: 20px;\n    height: 20px;\n}\n\n.downloadMenu {\n    background-color: white;\n    border-radius: 6px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    padding: 8px 0;\n    min-width: 200px;\n    max-height: 300px;\n    overflow-y: auto;\n    margin-top: 4px;\n    z-index: 100;\n}\n\n.downloadMenuItem {\n    font-size: 15px;\n    padding: 10px 16px;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    /* Make sure we use the same font as the rest of the PoD */\n    font-family: 'BauerMediaSans';\n    cursor: pointer;\n    color: #333;\n    border-left: 3px solid transparent;\n}\n\n    .downloadMenuItem:hover {\n        background-color: #f0f9fa;\n        color: var(--bmo-primary-color-mint-dark);\n        border-left: 3px solid var(--bmo-primary-color-mint);\n    }\n\n.downloadMenuItemDisabled {\n    color: #bbb;\n    cursor: not-allowed;\n    background-color: #f9f9f9;\n}\n\n    .downloadMenuItemDisabled:hover {\n        background-color: #f9f9f9;\n        color: #bbb;\n        border-left: 3px solid transparent;\n    }\n\n.dropdownArrow {\n    margin-left: 6px;\n    width: 12px;\n    height: 12px;\n    transition: transform 0.2s ease;\n    filter: brightness(1)\n}\n\n.dropdownOpen .dropdownArrow {\n    transform: rotate(180deg);\n}\n\n/* Export error message */\n.exportError {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    background-color: #f8d7da;\n    color: #721c24;\n    padding: 10px 15px;\n    border-radius: 4px;\n    margin-top: 8px;\n    font-size: 14px;\n    z-index: 100;\n    white-space: normal;\n    max-width: 300px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    border-left: 4px solid #dc3545;\n}\n\n.topBar {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 55px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0 16px;\n    z-index: 30; /* Higher than submenu (submenu is another component)*/\n}\n\n.leftSection {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    padding-top: 10px;\n    min-height: 60px;\n    margin-top: 15px;\n}\n\n.statusTextContainer {\n    height: 20px;\n    margin-top: 10px;\n}\n\n.spacer {\n    width: 16px;\n    flex-shrink: 0;\n}\n\n.statusText {\n    font-size: 16px;\n    font-weight: 500;\n    color: #4b5563;\n    line-height: 1.2;\n}\n\n.circleContainer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n}\n\n.circle {\n    width: 50px;\n    height: 50px;\n    background-color: #d9d9d9;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.circleImage {\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n    object-fit: cover;\n}\n\n.circleText {\n    font-size: 12px;\n    color: white;\n    font-weight: bold;\n    text-align: center;\n}\n\n.circleWithText {\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 0 auto;\n    margin-top: 30px;\n}\n\n.circleWithText,\n.circleImage {\n    background-color: #e5e7eb;\n    border: 1px solid #e5e7eb;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.1), 0 0 100px rgba(0, 0, 0, 0.1);\n    transform-style: preserve-3d;\n    transition: transform 0.3s ease;\n}\n\n.circleDescription {\n    margin-top: 8px;\n    font-size: 13px;\n    text-align: center;\n    color: black;\n    font-weight: bold;\n    word-wrap: break-word;\n    max-width: 120px;\n}\n\n.productPromiseColor {\n    background-color: var(--bmo-primary-color-lavender);\n}\n\n.wrappedContent {\n    width: 100%;\n    height: 100%;\n    display: flex;\n}\n\n.bottomBar {\n    position: absolute;\n    bottom: 16px;\n    right: 16px;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    padding: 8px 16px;\n    z-index: 10;\n}\n\n    .bottomBar .statusText {\n        margin-right: 0; /* Override the auto margin from topBar */\n    }\n\n/* Map URL Modal Styles */\n.modalOverlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 10000;\n    pointer-events: auto;\n}\n\n.modal {\n    background-color: white;\n    border-radius: 8px;\n    padding: 24px;\n    max-width: 600px;\n    width: 90%;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n    animation: modalFadeIn 0.3s ease-out;\n}\n\n@keyframes modalFadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(-20px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.modal h3 {\n    margin-top: 0;\n    margin-bottom: 16px;\n    color: #111827;\n    font-size: 1.25rem;\n}\n\n.urlContainer {\n    display: flex;\n    margin: 16px 0;\n}\n\n.urlInput {\n    flex: 1;\n    padding: 8px 12px;\n    border: 1px solid #d1d5db;\n    border-radius: 4px 0 0 4px;\n    font-size: 14px;\n    background-color: #f9fafb;\n}\n\n.copyButton {\n    background-color: var(--bmo-primary-color-mint);\n    color: white;\n    border: none;\n    padding: 8px 16px;\n    border-radius: 8px;\n    /* border-radius: 0 4px 4px 0; */\n    cursor: pointer;\n    font-weight: 500;\n    transition: background-color 0.3s;\n}\n\n    .copyButton:hover {\n        background-color: var(--bmo-primary-color-mint-dark);\n    }\n\n.modalNote {\n    color: #6b7280;\n    font-size: 14px;\n    margin-bottom: 20px;\n}\n\n.modalButtons {\n    display: flex;\n    justify-content: flex-end;\n}\n\n.closeButton {\n    background-color: #e5e7eb;\n    color: #111827;\n    border: none;\n    padding: 8px 16px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-weight: 500;\n    transition: background-color 0.3s;\n}\n\n    .closeButton:hover {\n        background-color: #d1d5db;\n    }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AddTopLevelIconAndText-module__container___LsgJ_`,
	"promiseAndStatusContainer": `AddTopLevelIconAndText-module__promiseAndStatusContainer___xn6yD`,
	"dropdownContainer": `AddTopLevelIconAndText-module__dropdownContainer___pV9Xf`,
	"downloadButton": `AddTopLevelIconAndText-module__downloadButton___OBTN6`,
	"downloadButtonWithBorder": `AddTopLevelIconAndText-module__downloadButtonWithBorder___vFdYA`,
	"downloadButtonDisabled": `AddTopLevelIconAndText-module__downloadButtonDisabled____vtMN`,
	"downloadIcon": `AddTopLevelIconAndText-module__downloadIcon___BB3l8`,
	"downloadMenu": `AddTopLevelIconAndText-module__downloadMenu___O7H2V`,
	"downloadMenuItem": `AddTopLevelIconAndText-module__downloadMenuItem___LBWFR`,
	"downloadMenuItemDisabled": `AddTopLevelIconAndText-module__downloadMenuItemDisabled___wb7JB`,
	"dropdownArrow": `AddTopLevelIconAndText-module__dropdownArrow___Yjp2k`,
	"dropdownOpen": `AddTopLevelIconAndText-module__dropdownOpen___ynE6V`,
	"exportError": `AddTopLevelIconAndText-module__exportError____9M4V`,
	"topBar": `AddTopLevelIconAndText-module__topBar___DKXZx`,
	"leftSection": `AddTopLevelIconAndText-module__leftSection___Z741R`,
	"statusTextContainer": `AddTopLevelIconAndText-module__statusTextContainer___IUVYD`,
	"spacer": `AddTopLevelIconAndText-module__spacer___hvi9s`,
	"statusText": `AddTopLevelIconAndText-module__statusText___wGNLW`,
	"circleContainer": `AddTopLevelIconAndText-module__circleContainer___z6VCi`,
	"circle": `AddTopLevelIconAndText-module__circle___oDSbg`,
	"circleImage": `AddTopLevelIconAndText-module__circleImage___cKYly`,
	"circleText": `AddTopLevelIconAndText-module__circleText___YWzjq`,
	"circleWithText": `AddTopLevelIconAndText-module__circleWithText___j_KMR`,
	"circleDescription": `AddTopLevelIconAndText-module__circleDescription___pllbB`,
	"productPromiseColor": `AddTopLevelIconAndText-module__productPromiseColor___ca24M`,
	"wrappedContent": `AddTopLevelIconAndText-module__wrappedContent___aKV9B`,
	"bottomBar": `AddTopLevelIconAndText-module__bottomBar___n0FqW`,
	"modalOverlay": `AddTopLevelIconAndText-module__modalOverlay___sSJN5`,
	"modal": `AddTopLevelIconAndText-module__modal___BzIKB`,
	"modalFadeIn": `AddTopLevelIconAndText-module__modalFadeIn___Ulpgi`,
	"urlContainer": `AddTopLevelIconAndText-module__urlContainer___Tldyj`,
	"urlInput": `AddTopLevelIconAndText-module__urlInput___hMGCU`,
	"copyButton": `AddTopLevelIconAndText-module__copyButton____IsT4`,
	"modalNote": `AddTopLevelIconAndText-module__modalNote___UCDyT`,
	"modalButtons": `AddTopLevelIconAndText-module__modalButtons___de2yq`,
	"closeButton": `AddTopLevelIconAndText-module__closeButton___MvrRH`
};
export default ___CSS_LOADER_EXPORT___;
